import { Step } from "react-joyride";

const trialUserEditPlantInformationTourSteps: Step[] = [
  {
    target: ".tour-plant-name",
    content: "Here you will enter a local Plant you use to pull or deposit material.",
    skipScroll: true,
    buttons: ["back", "close", "primary"],
  },
  {
    target: ".tour-plant-phone",
    content: "Enter the Plant’s Phone Number.",
    skipScroll: true,
    buttons: ["back", "close", "primary"],
  },
  {
    target: ".tour-plant-address",
    content: "Enter the Plant’s Address.",
    skipScroll: true,
    buttons: ["back", "close", "primary"],
  },
  {
    target: ".tour-plant-material-name",
    content: "Choose your plant material.",
    buttons: ["back", "close", "primary"],
  },
  {
    target: ".tour-plant-material-rate",
    content: "Enter your price per ton for the material.",
    buttons: ["back", "close", "primary"],
  },
];

export default trialUserEditPlantInformationTourSteps;
